// @flow
import { AppContainer } from 'react-hot-loader';
import 'react-hot-loader/patch';
import React from 'react';
import type { ComponentType } from 'react';
import ReactDOM from 'react-dom';

import { I18nProvider } from '@lingui/react';
import { i18nConfig } from '@rover/utilities/translation';
import ThemeProvider from '@rover/react-lib/components/utils/ThemeProvider';

export default <Props>(
  Component: ComponentType<Props>,
  elementSelector: string,
  props?: Props
): void => {
  const rootElement = document.querySelector(elementSelector);
  const container = (
    <AppContainer>
      <I18nProvider {...i18nConfig}>
        <ThemeProvider>
          <Component {...props} />
        </ThemeProvider>
      </I18nProvider>
    </AppContainer>
  );
  if (!rootElement) {
    throw new Error('rootElement not found.');
  }
  ReactDOM.render(container, rootElement);
};



// WEBPACK FOOTER //
// ../react-lib/src/utils/renderRootElement.jsx